import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

export async function writeAuditLog(pharmacyId, user, details = {}) {
  if (!pharmacyId) return;

  const actorEmail = user?.email || details.actorEmail || 'unknown';
  const actorUid = user?.uid || details.actorUid || 'unknown';

  try {
    await addDoc(collection(db, 'pharmacies', pharmacyId, 'activityLogs'), {
      timestamp: serverTimestamp(),
      actorUid,
      actorEmail,
      userId: actorUid,
      displayName: user?.displayName || actorEmail,
      actorRole: details.actorRole || '',
      action: details.action || 'Activity recorded',
      entityType: details.entityType || '',
      entityId: details.entityId || '',
      entityName: details.entityName || '',
      previousValue: details.previousValue ?? '',
      newValue: details.newValue ?? '',
      source: details.source || 'client',
      metadata: details.metadata || {},
    });
  } catch (err) {
    console.error('Audit log failed:', err);
  }
}
